export interface IAssetsConfig {
  location: string,
}

const assetsConfig: IAssetsConfig = {
  location: '_next/static/frontend/static',
};

export default assetsConfig;
